import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const removeActiveSession = createAsyncThunk('user/removeActiveSession', async (uuid: string) => {
	return await AccountService.removeActiveSessions(uuid);
});
